import React, { memo } from "react";
import { useSelector } from "react-redux";
import {
  selectDisplayTiming,
  selectCountingTime,
  selectIsCountingTime,
} from "redux/timing/selectors";
import { Tooltip } from "@material-ui/core";
import InfoIcon from "@material-ui/icons/Info";
import PlayIcon from "@material-ui/icons/PlayArrow";
import PauseIcon from "@material-ui/icons/Pause";
import style from "./style.module.scss";

const CountTiming = () => {
  const countingTime = useSelector(selectCountingTime);
  const isCountingTime = useSelector(selectIsCountingTime);
  const displayTime = useSelector(selectDisplayTiming);
  return (
    <div className={style.timing}>
      <div className={style.timingContainer}>
        {countingTime || isCountingTime ? (
          <PauseIcon className={style.timingIcon} />
        ) : (
          <PlayIcon className={style.timingIcon} />
        )}{" "}
        {displayTime}
      </div>
      <Tooltip
        title={
          <div className={style.timeTooltip}>
            <p>Total annotation session time</p>
            <p>
              The clock starts counting time when you open the labeling tool and
              this total time will be subtracted to monthly annotation time.
            </p>
          </div>
        }
      >
        <InfoIcon />
      </Tooltip>
    </div>
  );
};

export default memo(CountTiming);
